import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import {
  Container, Header, Menu, Segment,
} from 'semantic-ui-react';
import Selectors from '@/themes/hooks/selectors';
import Events from '../hooks/events';

const AuthCallback = () => {
  Events.useSignInCallback();
  const { theme } = Selectors.useTheme();

  return (
    <>
      <Menu inverted className={clsx('nav fixed no-full-screen', `aridhia-theme-${theme}`)} />
      <Container className={clsx('page content aridhia-logout-page', `aridhia-theme-${theme}`)}>
        <Segment className="container" textAlign="center" size="large" padded="very">
          <Header as="h2">
            <FormattedMessage id="authenticating.title" />
          </Header>
          <Header as="h4">
            <FormattedMessage id="authenticating.content" />
          </Header>
        </Segment>
      </Container>
    </>
  );
};

export default AuthCallback;
